module.exports = __webpack_public_path__ + "static/media/medical center.95395024.svg";